import { prodHostname } from './prodHostname.mjs'

export const prodOrigin = `https://${prodHostname}`
